export default "__VITE_ASSET__b7Shj0s7__"